// TypeSafe desde el navegador: siempre vía Netlify Functions (la key no llega acá).

// Clasificación con TypeSafe (netlify/functions/clasificar.mjs). Nunca bloquea
// el flujo: si no contesta, el dato queda vacío y todo sigue como antes.
export const clasificar = (tipo, texto) =>
  fetch('/fn/clasificar', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tipo, texto }),
  }).then(r => r.json()).then(d => (d?.ok ? d : null)).catch(() => null);

// Rubro pre-llenado en WebChat y Dashboard. Solo con confianza alta: debajo de
// 0.7 conviene el campo vacío antes que uno equivocado. 'otro' no pre-llena.
export const RUBRO_LABEL = {
  gastronomia: 'Gastronomía',
  salud: 'Salud',
  indumentaria: 'Indumentaria',
  construccion: 'Construcción y arquitectura',
  servicios_profesionales: 'Servicios profesionales',
  educacion: 'Educación',
  belleza_bienestar: 'Belleza y bienestar',
  comercio: 'Comercio',
  inmobiliaria: 'Inmobiliaria',
  turismo: 'Turismo',
  tecnologia: 'Tecnología',
};
export const CONFIANZA_MINIMA = 0.7;

// Cada sugerencia queda en la pestaña "TypeSafe" de la planilla, con el valor
// final, para medir con casos reales y mejorar las preguntas
// (netlify/functions/registrar-typesafe.js). Fire and forget.
export const registrarTypeSafe = (datos) => {
  try {
    fetch('/.netlify/functions/registrar-typesafe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(datos),
    }).catch(() => {});
  } catch {}
};
